import { render, staticRenderFns } from "./DossierInfoForm.vue?vue&type=template&id=1f8008b9&"
import script from "./DossierInfoForm.vue?vue&type=script&lang=ts&"
export * from "./DossierInfoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f8008b9')) {
      api.createRecord('1f8008b9', component.options)
    } else {
      api.reload('1f8008b9', component.options)
    }
    module.hot.accept("./DossierInfoForm.vue?vue&type=template&id=1f8008b9&", function () {
      api.rerender('1f8008b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierInfoForm.vue"
export default component.exports